export default "/_next/static/images/fa5ca83252539bd1790c69795fe7e16b.png";